import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)


const routes = [{
		path: '/',
		redirect: '/login'
	}, {
		path: '/login',
		name: 'login',
		component: resolve => require(['@/page/auth/login'], resolve),
		meta: {
			auth: true,
			menu: false,
			name: '登录'
		}
	},
	/* {
		path: '/user_center',
		name: 'user_center',
		component: EmptyLayout,
		meta: { auth: true, menu: false, name: '用户中心' },
		children: [
			{
				path: '/user_center/edit',
				name: 'user_edit',
				component: resolve => require(['@/page/user_center/edit'], resolve),
				meta: { auth: true, menu: false, name: '修改个人信息' }
			}, {
				path: '/user_center/edit_pwd',
				name: 'user_edit_pwd',
				component: resolve => require(['@/page/user_center/edit_pwd'], resolve),
				meta: { auth: true, menu: false, name: '重置密码' }
			}, {
				path: '/user_center/edit_base',
				name: 'user_edit_base',
				component: resolve => require(['@/page/user_center/edit_base'], resolve),
				meta: { auth: true, menu: false, name: '个人中心' }
			}
		]
	}, {
		path: '/test',
		name: 'test',
		component: resolve => require(['@/page/test'], resolve),
		meta: { auth: false, menu: false, name: '测试' }
	} */
	{
		path: '/count_center',
		name: 'count_center',
		redirect: '/count_center/list',
		component: resolve => require(['@/page/count_center/home'], resolve),
		meta: {
			auth: true,
			menu: true,
			name: '首页',
			icon: 'el-icon-s-order',
			keepAlive: false
		},
		children: [{
			path: '/count_center/list',
			name: 'homelist',
			authority: '1000',
			meta: {
				auth: true,
				deepth: 0,
				menu: true,
				name: '首页',
				icon: 'el-icon-view',
				OffAppId: true,
				keepAlive: true,
			},
			component: resolve => require(['@/page/count_center/list'], resolve),
		},{
			path: '/count_center/learning_record',
			name: 'learning_record',
			authority: '1000',
			meta: {
				auth: true,
				deepth: 0,
				menu: true,
				name: '学习记录',
				icon: 'el-icon-view',
				OffAppId: true,
				keepAlive: true,
			},
			component: resolve => require(['@/page/count_center/learning_record'], resolve),
		}]
	},
	{
		path: '/count_center/player/:course_id/:type?/:video_id?/:debug?',
		name: 'count_center_player',
		component: resolve => require(['@/page/count_center/player'], resolve),
		meta: {
			auth: true,
			menu: true,
			name: '播放页',
			deepth: 1,
			icon: 'el-icon-s-order'
		}
	},
	{
		path: '/manage_center',
		name: 'manage_center',
		component: resolve => require(['@/page/manage_center/index'], resolve),
		redirect: '/manage_center/course_management',
		meta: {
			auth: true,
			menu: true,
			name: '管理中心',
			icon: 'el-icon-s-order'
		},
		children: [{
				path: '/manage_center/course_management',
				name: 'manage_center_courseManagement',
				authority: '1000',
				meta: {
					auth: true,
					menu: true,
					name: '课程管理',
					icon: 'el-icon-view',
					OffAppId: true
				},
				component: resolve => require(['@/page/manage_center/course_management/index'], resolve),
			},
			{
				path: '/manage_center/course_management/add',
				name: 'manage_center_courseManagement_add',
				authority: '1000',
				meta: {
					auth: true,
					menu: true,
					name: '新增课程',
					icon: 'el-icon-view',
					OffAppId: true
				},
				component: resolve => require(['@/page/manage_center/course_management/add'], resolve),
			},
			{
				path: '/manage_center/course_management/mostAdd',
				name: 'manage_center_courseManagement_mostAdd',
				authority: '1000',
				meta: {
					auth: true,
					menu: true,
					name: '新增系列课',
					icon: 'el-icon-view',
					OffAppId: true
				},
				component: resolve => require(['@/page/manage_center/course_management/mostAdd'], resolve),
			},
			{
				path: '/manage_center/study_records',
				name: 'manage_center_studyRecords',
				authority: '1000',
				meta: {
					auth: true,
					menu: true,
					name: '学习记录',
					icon: 'el-icon-view',
					OffAppId: true
				},
				component: resolve => require(['@/page/manage_center/study_records/index'], resolve),
			},
			{
				path: '/manage_center/study_records/info',
				name: 'manage_center_studyInfo',
				authority: '1000',
				meta: {
					auth: true,
					menu: true,
					name: '学习记录',
					icon: 'el-icon-view',
					OffAppId: true
				},
				component: resolve => require(['@/page/manage_center/study_records/info'], resolve),
			},
			{
				path: '/manage_center/login_manage',
				name: 'manage_center_loginManage',
				authority: '1000',
				meta: {
					auth: true,
					menu: true,
					name: '登录授权管理',
					icon: 'el-icon-view',
					OffAppId: true
				},
				component: resolve => require(['@/page/manage_center/login_manage/index'], resolve),
			},
		]
	},
]


const router = new VueRouter({
	routes
})

router.beforeEach((to, from, next) => {
	const token = localStorage.getItem('token')
	const userinfo = localStorage.getItem('user_info')
	if (to.path == '/login' || to.path == '/') {
		// 判断是否已经登录
		if(token && userinfo){
			next('/count_center/list')
		}else{
			next()
		}
	} else if (!token || !userinfo) {
		next('/login')
	} else {
		next()
	}
})


export default router